module.exports = __webpack_public_path__ + "img/2024_bnr1160_1.88ad764.png";